import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-password-reset-confirmation',
  templateUrl: './password-reset-confirmation.component.html',
  styleUrls: ['./password-reset-confirmation.component.scss'],
})
export class PasswordResetConfirmationComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<PasswordResetConfirmationComponent>,
  ) {}

  ngOnInit() {}
  confirm() {
    this.dialogRef.close(true);
  }
}
